/* eslint-disable jsx-a11y/iframe-has-title */
import { ComponentProps, forwardRef } from 'react';

const IFrame = forwardRef<HTMLIFrameElement, ComponentProps<'iframe'>>(
  (props, ref) => <iframe ref={ref} {...props} />,
);

export default IFrame;
